export const ENCRYPTION_EXPIRY_DURATION = 15 * 60 * 1000; // 15 minutes
